import React from "react";
import { Typography, Button, Box } from "@mui/material";
import { GitHub, Instagram, LinkedIn } from "@mui/icons-material";
import { useTheme } from '@mui/material/styles';

const Footer = () => {
  const theme = useTheme();
  
  return (
    <Box sx={{
      display: "flex",
      flexDirection: { xs: "column", md: "row" },
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1,
      maxWidth: 1040,
      mx: "auto",
      px: { xs: 3, md: 0 },
      py: 3,
      borderTop: 1,
      borderColor: "divider",
      marginTop: theme.spacing(5),
    }}>
      <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontStyle: "italic" }}>
        All content and opinions are my own.
      </Typography>
      <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
        Find me elsewhere
      </Typography>
      <Button
        href="https://www.instagram.com/a.la.cat?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
        target="_blank"
        sx={{ color: theme.palette.text.secondary }}
        startIcon={<Instagram />}
      >
        Instagram
      </Button>
       <Button
        href="https://www.linkedin.com/in/catalina-ionescu-848618113/"
        target="_blank"
        rel="noreferrer"
        sx={{ color: theme.palette.text.secondary }}
        startIcon={<LinkedIn />}
      >
       LinkedIn
      </Button>
      <Button
        href="https://github.com/icatat"
        target="_blank"
        rel="noreferrer"
        sx={{ color: theme.palette.text.secondary }}
        startIcon={<GitHub />}
      >
       GitHub
      </Button>
      
    </Box>
  );
};


export default Footer;
